import { deleteUserByIds, restoreUser, restoreUsers } from "@/api/users";
import { simpleDate } from "@/utils/filters/dateFilters";
import { mapState, mapGetters, mapMutations } from "vuex";

export const mixinAdminPanelUsers = {
  data() {
    return {
      selectedUsersIds: [],
      paramsWidthSort: {
        page: 1,
        sort: '',
        search: '',
        trashed: false,
      },
      search: '',
      isTrashed: false
    }
  },

  async mounted() {
    const params  = {
      page: 1,
      sort: 'id',
      trashed: this.isTrashed
    }

    if (this.roleId) params.role = this.roleId
    this.getUsersByParams(params)
  },

  computed: {
    ...mapGetters("departments", ["getDepartmentById"]),
    ...mapGetters('users', ['getUsersListPagination']),
    ...mapState("departments", ["departments"]),

    pagination () {
      return this.getUsersListPagination
    },
    mapedUsers() {
      return this.users?.map((user) => {
        if (user.department) {
          const include = this.departments?.filter(dep => dep?.id === user.department.id)
          if (!include.length) {
            this.departments.unshift(user.department)
            this.SET_DEPARTMENTS(this.departments)
          }
        }
        const data = [
          user.deleted_at,
          user.id,
          user.created_at ? simpleDate(user.created_at) : "-",
          user.updated_at ? simpleDate(user.updated_at) : "-",
          user.surname || "-",
          user.name || "-",
          user.patronymic || "-",
          user.email || "-",
          user.login || "-",
          { data: this.getDepartmentById(user?.department_id) || '-', mod: 'department' },
          user.phone ? user.phone : "-"
        ];
        if (this.usersColumns?.find(item => item.title === 'VIP')) data.push(user.is_vip ? "Да" : "Нет",)
        return data
      });
    },
    selectedIndices: {
      get() {
        const indeces = [];

        this.users.forEach((order, i) => {
          if (this.selectedUsersIds[order.id] !== undefined) {
            indeces.push(i);
          }
        });

        return indeces;
      },
      set(val) {
        const ids = [];
        for (let index = 0; index < val.length; index++) {
          const user = this.users[val[index]];
          if (user?.id) ids[user.id] = user;
        }
        this.selectedUsersIds = ids;
      },
    },
    rowIds() {
      const array = []
      this.removeUsers().forEach(id => {
        let idx = this.mapedUsers.findIndex(item => {
          return item[1] === id
        })
        if (idx !== -1) {
          idx += 1
          array.push(idx)
        }
      })
      return array
    },
  },

  methods: {
    ...mapMutations("departments", ["SET_DEPARTMENTS"]),

    select(value, index, all = null) {
      if (all !== null) {
        this.selectedIndices = all ? this.users.map((el, i) => i) : [];
      } else if (value) {
        this.selectedIndices = [...this.selectedIndices, index];
      } else {
        this.selectedIndices = this.selectedIndices.filter((i) => i === index);
      }
    },

    openUser(num) {
      if (this.rowIds.includes(num)) {
        const restoreCallback = async () => {
          await restoreUser(this.users[num - 1].id)
            .then(() => {
              this.$root.alert("Пользователи успешно восстановлены");
            })
            .catch(() => {
              this.$root.alert("При восстановлении пользователей произошла ошибка");
            })
            .finally(() => {
              const params = {
                page: this.pagination.currentPage,
                sort: this.paramsWidthSort.sort,
                search: this.paramsWidthSort.search,
                trashed: this.paramsWidthSort.trashed
              }
              if (this.roleId) params.role = this.roleId
              this.getUsersByParams(params)
            });
        };
        this.$root.confrim(
            "Вы уверены, что хотите восстановить пользователей?",
            restoreCallback,
            "Да"
        );
      } else {
        this.$router.push(
            this.urlProfile + this.users[num - 1].id
        )
      }
    },
    delete() {
      if (this.selectedUsersIds.length) {
        const deleteCallback = async () => {
          await deleteUserByIds(this.selectedUsersIds)
            .then(() => {
              this.$root.alert("Пользователи успешно удалены");
            })
            .catch(() => {
              this.$root.alert("При удалении пользователей произошла ошибка");
            })
            .finally(() => {
              this.selectedUsersIds = []
              const params = {
                page: this.pagination.currentPage,
                sort: this.paramsWidthSort.sort,
                search: this.paramsWidthSort.search,
                trashed: this.paramsWidthSort.trashed
              }

              if (this.roleId) params.role = this.roleId
              this.getUsersByParams(params)
            })
        }
        this.$root.confrim(
            "Вы уверены, что хотите удалить пользователей?",
            deleteCallback,
            "Да"
        );
      }
    },

    removeUsers () {
      return this.users
          .filter(user => user.deleted_at !== null)
          .map(user => user.id)
    },

    restore() {
      if (this.selectedUsersIds.length) {
        const restoreCallback = async () => {
          await restoreUsers(this.selectedUsersIds)
            .then(() => {
              this.$root.alert("Пользователи успешно восстановлены");
            })
            .catch(() => {
              this.$root.alert("При восстановлении пользователей произошла ошибка");
            })
            .finally(() => {
              this.selectedUsersIds = []
              const params = {
                page: this.pagination.currentPage,
                sort: this.paramsWidthSort.sort,
                search: this.paramsWidthSort.search,
                trashed: this.paramsWidthSort.trashed
              }
              if (this.roleId) params.role = this.roleId
              this.getUsersByParams(params)
            })
        };
        this.$root.confrim(
            "Вы уверены, что хотите восстановить пользователей?",
            restoreCallback,
            "Да"
        )
      }
    },
    create() {
      this.$router.push(
          this.urlSave
      );
    },

    getPage (pageNum) {
      const params  = {
        page: pageNum,
        sort: this.paramsWidthSort.sort,
        search: this.paramsWidthSort.search,
        trashed: this.paramsWidthSort.trashed,
      }

      if (this.roleId) this.paramsWidthSort.role = this.roleId
      this.getUsersByParams(params)
    },

    sortUsers(col, sort) {
      this.paramsWidthSort = {
        page: 1,
        sort: (sort ? "" : "-") + col?.value,
        search: this.paramsWidthSort.search,
        trashed: this.paramsWidthSort.trashed,
      }

      if (this.roleId) this.paramsWidthSort.role = this.roleId
      this.getUsersByParams(this.paramsWidthSort)
    },

    searchUsers() {
      this.paramsWidthSort = {
        page: 1,
        sort: this.paramsWidthSort.sort,
        search: this.search,
        trashed: this.paramsWidthSort.trashed,
      }

      if (this.roleId) this.paramsWidthSort.role = this.roleId
      this.getUsersByParams(this.paramsWidthSort)
    },

    getTrashedItems () {
      this.paramsWidthSort = {
        page: 1,
        sort: this.paramsWidthSort.sort,
        search: this.paramsWidthSort.search,
        trashed: this.isTrashed
      }
      if (this.roleId) this.paramsWidthSort.role = this.roleId
      this.getUsersByParams(this.paramsWidthSort)
    },
  },

  destroyed () {
    this.$store.commit('users/RESET_USERS_LIST_CURRENT_PAGE')
  },
}